import { render, staticRenderFns } from "./FortnoxCustomerList.vue?vue&type=template&id=9ae05d2a"
import script from "./FortnoxCustomerList.vue?vue&type=script&lang=ts"
export * from "./FortnoxCustomerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports